// ------- money format function -------          
function formatMoney(cents, format) {
  if (typeof cents === "string") cents = cents.replace(".", "");
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || "${{amount}}";

  const number = (cents / 100).toFixed(2);
  value = number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

  return formatString.replace(placeholderRegex, value);
}

// --- custom Add to cart function  ----
function customQuickATC(){
  let atcErrorTimeoutId = null;
  document.addEventListener("click", async function (e) {
    const btn = e.target.closest(".quick-add-size-btn");
    if (!btn) return;
    if (
      btn.matches(":disabled") ||
      btn.getAttribute("aria-disabled") === "true" ||
      btn.classList.contains("disabled")
    ) return;

    const variantId = btn.getAttribute("data-variant");
    if (!variantId) return;

    // Identify the Product Card (Desktop) vs. the Popup (Mobile)
    const isMobilePopup = btn.closest("#quickAddMobileContainer");
    const product_card = e.target.closest(".product-card-wrapper");

    const cardContainer = isMobilePopup || product_card;

    const errorWrapper = cardContainer?.querySelector(".product-form__error-message-wrapper");
    const errorMessageEl = cardContainer?.querySelector(".product-form__error-message");
    const loaderEl = cardContainer?.querySelector(".product-card__spinner");

    if (atcErrorTimeoutId) {
      clearTimeout(atcErrorTimeoutId);
    }

    if (loaderEl) loaderEl.classList.remove("hidden");

    try {
      const config = { ...fetchConfig('javascript') };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('form_type', 'product');
      formData.append('sections', "cart-drawer,cart-icon-bubble");
      config.body = formData;

      const response = await fetch(`${routes.cart_add_url}`, config);
      const data = await response.json();

      if (!response.ok || data.status || data.description) {
        const errorMessage = data.description || data.message || "Something went wrong!";
        throw new Error(errorMessage);
      }

      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        if (cartDrawer.classList.contains("is-empty")) {
          cartDrawer.classList.remove("is-empty");
        }
        cartDrawer.renderContents(data);
        cartDrawer.open();
      }
      if (isMobilePopup) {
        document.getElementById("quickAddMobileContainer").classList.remove("is-active");
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: formData.get('id'),
        cartData: data,
      });
    } catch (error) {
      console.error("Error adding to cart:", error);
      
      if (errorMessageEl && errorWrapper) {
        errorMessageEl.textContent = error.message;
        errorWrapper.removeAttribute("hidden");
        atcErrorTimeoutId = setTimeout(() => {
          errorWrapper.setAttribute("hidden", "");
          errorMessageEl.textContent = "";
        }, 7000); 
      }
    } finally {
      if (loaderEl) {
        loaderEl.classList.add("hidden");
      }
    }
  });
}

// ------- function to update color product content on swatch click in product card -----------
function updateProductCardOnSwatchClick(){
  const CARD_SELECTORS = {
    title: ".card__heading-text",
    color: ".product-color-name",
    quickAddTitle: ".quick-add-text",
    priceContainer: ".price__card-product-info",
    priceRegular: ".price__regular",
    priceSale: ".price__sale",
    media: ".card__media .media img",
    sizeContainer: ".quick-add-sizes",
    soldOutBadge: ".badge--sold-out",
    swatches: ".color-swatch-item",
    defaultSizeContainer: ".card__default-option",
    mobileQuickAdd: ".quick-add-mobile",
    saveBadge: "[data-save-badge]",
    marketingBadge: "[data-marketing-badge]",
    badgeWrapper: "[data-product-badge-wrapper]",
    saleExclusionContainer: "[data-sale-exclusion-container]",
    standardBadgesContainer: "[data-standard-badges-container]",
  };

  // Cache parsed product JSON
  const swatchProductCache = new Map();

  document.addEventListener("click", function (e) {
    const swatch = e.target.closest(CARD_SELECTORS.swatches);
    if (!swatch) return;

    const card = swatch.closest(".card-wrapper");
    if (!card) return;

    // Prevent unnecessary re-render
    if (swatch.classList.contains("active")) return;

    // DATA EXTRACTION & VALIDATION
    const productId = swatch.getAttribute("card-product-id");
    const jsonEl = document.getElementById(`GroupProducts-${productId}`);
    if (!jsonEl) return;

    let products = swatchProductCache.get(productId);

    if (!products) {
      try {
        products = JSON.parse(jsonEl.textContent);
        swatchProductCache.set(productId, products);
      } catch (err) {
        console.error("Invalid product JSON", err);
        return;
      }
    }

    const selectedProduct = products.find(
      p => String(p.id) === String(swatch.dataset.productId)
    );


    if (!selectedProduct) return;

    const isProductSoldOut = !selectedProduct.available || selectedProduct.has_hidden_inventory_tag;

    // CACHE DOM ELEMENTS
    const titleEl = card.querySelector(CARD_SELECTORS.title);
    const colorEl = card.querySelector(CARD_SELECTORS.color);
    const priceContainerEl = card.querySelector(CARD_SELECTORS.priceContainer);
    const priceRegularEl = card.querySelector(CARD_SELECTORS.priceRegular);
    const priceSaleEl = card.querySelector(CARD_SELECTORS.priceSale);
    const sizeContainer = card.querySelector(CARD_SELECTORS.sizeContainer);
    const defaultSizeContainer = card.querySelector(CARD_SELECTORS.defaultSizeContainer);
    const badgesEl = card.querySelectorAll(CARD_SELECTORS.soldOutBadge);
    const mobileQuickAddEl = card.querySelector(CARD_SELECTORS.mobileQuickAdd);
    const images = card.querySelectorAll(CARD_SELECTORS.media);
    const linkEls = card.querySelectorAll("a");
    const quickAddTitleEl = card.querySelector(CARD_SELECTORS.quickAddTitle);

    // UPDATE TEXT CONTENT ONLY IF CHANGED
    // if (titleEl && titleEl.textContent !== selectedProduct.title) {
    //   console.log("titleEl : ", titleEl.textContent, " | selectedProduct.title : ", selectedProduct.title);
    //   titleEl.textContent = selectedProduct.title;
    // }

    if (colorEl && colorEl.textContent !== selectedProduct.color) {
      colorEl.textContent = selectedProduct.color;
    }

    if (priceContainerEl && priceRegularEl && priceSaleEl) {
      const regularPriceItem = priceRegularEl.querySelector('.price-item--regular');
      const salePriceRegularItem = priceSaleEl.querySelector('.price-item--regular');
      const salePriceItem = priceSaleEl.querySelector('.price-item--sale');
      const formattedLowestPrice = formatMoney(selectedProduct.lowest_price, window.storeSettings.moneyFormat);
      if (selectedProduct.has_lowest_price_compare_at) {
        const formattedCompareAtPrice = formatMoney(selectedProduct.lowest_price_compare_at, window.storeSettings.moneyFormat);
        if (salePriceRegularItem) salePriceRegularItem.textContent = formattedCompareAtPrice;
        if (salePriceItem) salePriceItem.textContent = formattedLowestPrice;
        priceContainerEl.classList.add('price--on-sale');
      } else {
        if (regularPriceItem) regularPriceItem.textContent = formattedLowestPrice;
        priceContainerEl.classList.remove('price--on-sale');
      }
    }

    // --- BADGE PRIORITY & SWATCH UPDATE HANDLING ---
    const isExcluded = selectedProduct.is_sale_excluded;
    const badgeWrappers = card.querySelectorAll(CARD_SELECTORS.badgeWrapper);

    badgeWrappers.forEach((wrapper) => {
      const saleExclContainer = wrapper.querySelector(CARD_SELECTORS.saleExclusionContainer);
      const standardBadgesContainer = wrapper.querySelector(CARD_SELECTORS.standardBadgesContainer);

      if (saleExclContainer && standardBadgesContainer) {
        if (isExcluded) {
          saleExclContainer.removeAttribute('hidden');
          standardBadgesContainer.setAttribute('hidden', '');
        } else {
          saleExclContainer.setAttribute('hidden', '');
          standardBadgesContainer.removeAttribute('hidden');
        }
      }
    });

    if (!isExcluded) {
      const saveBadgeEls = card.querySelectorAll(CARD_SELECTORS.saveBadge);
      const marketingBadgeEls = card.querySelectorAll(CARD_SELECTORS.marketingBadge);
      const hasEarlyAccessTag = selectedProduct.has_early_access === true;

      saveBadgeEls.forEach((saveBadgeEl) => {
        const isSaveEligible =
          selectedProduct.has_lowest_price_compare_at &&
          selectedProduct.lowest_price_compare_at > selectedProduct.lowest_price;

        let savePercent = 0;
        if (isSaveEligible) {
          savePercent = Math.round(
            ((selectedProduct.lowest_price_compare_at - selectedProduct.lowest_price) /
              selectedProduct.lowest_price_compare_at) *
              100
          );
        }

        if (isSaveEligible && savePercent > 0 && !hasEarlyAccessTag) {
          const labelTemplate = saveBadgeEl.dataset.saveBadgeLabel || 'SAVE __PERCENT__%';
          saveBadgeEl.textContent = labelTemplate.replace('__PERCENT__', String(savePercent));
          saveBadgeEl.hidden = false;
          saveBadgeEl.style.display = '';
        } else {
          saveBadgeEl.textContent = '';
          saveBadgeEl.hidden = true;
          saveBadgeEl.style.display = 'none';
        }
      });

      marketingBadgeEls.forEach((marketingBadgeEl) => {
        const badgeText = selectedProduct.marketing_badge;
        if (badgeText) {
          marketingBadgeEl.textContent = String(badgeText).toUpperCase();
          marketingBadgeEl.hidden = false;
          marketingBadgeEl.style.display = '';
        } else {
          marketingBadgeEl.textContent = '';
          marketingBadgeEl.hidden = true;
          marketingBadgeEl.style.display = 'none';
        }
      });
    }

    if (quickAddTitleEl) {
      const textQuickAdd = quickAddTitleEl.dataset.textQuickAdd;
      const textSoldOut = quickAddTitleEl.dataset.textSoldOut;
      quickAddTitleEl.textContent = isProductSoldOut ? textSoldOut : textQuickAdd;
      quickAddTitleEl.classList.toggle("is-sold-out", isProductSoldOut);
    }

    // Check the availability and disabled Add to bag button
    if (defaultSizeContainer) {
      const currentBtn = defaultSizeContainer.querySelector('.quick-add-size-btn');
      const nextContainer = defaultSizeContainer.nextElementSibling;
      const nextBtn = nextContainer ? nextContainer.querySelector('.quick-add-size-btn') : null;

      if (currentBtn) {
        currentBtn.setAttribute("data-variant", selectedProduct.variants[0].id);
        const textSoldOut = currentBtn.dataset.textSoldOut;
        const textAddToCart = currentBtn.dataset.textAddToCart;
        currentBtn.textContent = isProductSoldOut ? textSoldOut : textAddToCart;
        currentBtn.classList.toggle("is-sold-out", isProductSoldOut);
      }
      if (nextBtn) nextBtn.setAttribute("data-variant", selectedProduct.variants[0].id);

      if (!selectedProduct.available || selectedProduct.has_hidden_inventory_tag) {
        if (currentBtn) currentBtn.setAttribute('disabled', '');
        if (nextBtn) {
          nextBtn.setAttribute('aria-disabled', 'true');
          nextBtn.classList.add('disabled');
        }
      } else {
        if (currentBtn) currentBtn.removeAttribute('disabled');
        if (nextBtn) {
          nextBtn.removeAttribute('aria-disabled');
          nextBtn.classList.remove('disabled');
        }
      }
    }

    if (mobileQuickAddEl) {
      mobileQuickAddEl.classList.toggle("hidden", isProductSoldOut);
    }

    // Sold out badge
    badgesEl.forEach(badgeEl => {
      if (badgeEl) {
        badgeEl.style.display = selectedProduct.available && !selectedProduct.has_hidden_inventory_tag ? "none" : "block";
      }
    });

    // Product links
    linkEls.forEach(link => {
      if (link.href !== selectedProduct.url) {
        link.href = selectedProduct.url;
      }
    });

    // Update Size Variant
    if (sizeContainer) {
      const fragment = document.createDocumentFragment();

      selectedProduct.variants.forEach(variant => {
        const btn = document.createElement("button");
        const spanEl = document.createElement("span");

        btn.type = "button";
        btn.className = "quick-add-size-btn";
        btn.setAttribute("data-variant", variant.id);
        btn.textContent = variant.variant_title;

        spanEl.className = "size-sold-out-text large-up-hide";
        spanEl.textContent = ` - ${window.variantStrings.sizeSoldOut}`;

        if (!variant.available || selectedProduct.has_hidden_inventory_tag) {
          btn.disabled = true;
          btn.classList.add("disabled");
        }

        if (!variant.available) {
          btn.appendChild(spanEl);
        }

        fragment.appendChild(btn);
      });

      sizeContainer.replaceChildren(fragment);
    }

    // IMAGE UPDATES
    if (images.length) {
      if (images[0] && selectedProduct.main_image) {
        images[0].removeAttribute("srcset");

        if (images[0].src !== selectedProduct.main_image) {
          images[0].src = selectedProduct.main_image;
        }
      }

      if (images[1] && selectedProduct.second_image) {
        images[1].removeAttribute("srcset");

        if (images[1].src !== selectedProduct.second_image) {
          images[1].src = selectedProduct.second_image;
        }
      }
    }

    // ACTIVE SWATCH STATE
    const activeSwatch = card.querySelector(
      `${CARD_SELECTORS.swatches}.active`
    );

    if (activeSwatch) {
      activeSwatch.classList.remove("active");
    }

    swatch.classList.add("active");
    positionSwatchInventoryTag(swatch);
  });
}

function positionSwatchInventoryTag(swatch) {
  if (!swatch) return;

  const tag = swatch.querySelector(".swatch-inventory-tag");
  if (!tag) return;

  const card = swatch.closest(".product-card-wrapper") || swatch.closest(".card-wrapper");
  if (!card) return;

  tag.style.setProperty("--swatch-tag-shift", "0px");

  // Force layout so measurements include the visible tag
  void tag.offsetWidth;

  const pad = 8;
  const tagRect = tag.getBoundingClientRect();
  const cardRect = card.getBoundingClientRect();
  let shift = 0;

  if (tagRect.left < cardRect.left + pad) {
    shift = cardRect.left + pad - tagRect.left;
  } else if (tagRect.right > cardRect.right - pad) {
    shift = cardRect.right - pad - tagRect.right;
  }

  tag.style.setProperty("--swatch-tag-shift", `${shift}px`);
}

function positionActiveSwatchInventoryTags(context = document) {
  const align = () => {
    context.querySelectorAll(".product-card-wrapper .color-swatch-item.active .swatch-inventory-tag").forEach((tag) => {
      positionSwatchInventoryTag(tag.closest(".color-swatch-item"));
    });
  };

  // Wait a frame so visibility/layout (e.g. is-hidden removed) is settled before measuring
  requestAnimationFrame(align);
}

// ---- Functions for handling the "More" link in product card color swatches. --------
function updateSwatchesNumber(context = document) {
  const containers = context.querySelectorAll(".card__swatch-wrapper");
  const existingCard = document.querySelector(".product-card-wrapper");
  const containerWidth = existingCard?.offsetWidth || 0;
  let fallBackSwatchWidth = existingCard?.querySelector('.color-swatch-item')?.offsetWidth || 0;

  if (containers && containers.length > 0) {
    containers.forEach((container) => {
      const swatches = container.querySelectorAll(".color-swatch-item");
      const moreLink = container.querySelector(".swatch-more-link");
      const counterEl = moreLink.querySelector(".swatch-rest-count");

      let visibleWidth = 0;
      let hiddenCount = 0;
      const moreLinkWidth = 40;
      let defaultSwatch = false;

      swatches.forEach((swatch, index) => {
        swatch.classList.remove("is-hidden");
        if (swatch.classList.contains('default')) {
          defaultSwatch = true;
        } 
        let swatchWidth = swatch.offsetWidth > 0 ? swatch.offsetWidth : fallBackSwatchWidth;
        let swatchGap = 8;
        visibleWidth += swatchWidth + swatchGap;
        if (visibleWidth > containerWidth - moreLinkWidth) {
          swatch.classList.add("is-hidden");
          hiddenCount++;
        } else if (defaultSwatch == false && (visibleWidth + moreLinkWidth + swatchWidth + swatchGap) > containerWidth) { 
            swatch.classList.add("is-hidden"); 
        }
      });

      if (hiddenCount > 0) {
        moreLink.style.display = "inline-flex";
        counterEl.innerText = `${hiddenCount}`;
      } else {
        moreLink.style.display = "none";
      }
    });
  }

  // Align inventory badges after swatch visibility is updated (skip detached fragments)
  const canMeasure =
    context === document ||
    (context?.nodeType === Node.ELEMENT_NODE && document.contains(context));

  if (canMeasure) {
    positionActiveSwatchInventoryTags(context);
  }
}

// ----  show quick add popup in mobile ----
function quickATCPopupMobile(){
  const mobilePopup = document.getElementById("quickAddMobileContainer");
  const popupContent = mobilePopup.querySelector(".quick-add__options");
  const closeBtn = mobilePopup.querySelector(".quick-add__close");

  document.addEventListener("click", function (event) {
    const iconClick = event.target.closest(".quick-add-icon");
    if (!iconClick) return;

    const productCard = iconClick.closest(".product-card-wrapper");
    const sizesHtml = productCard.querySelector(".quick-add-sizes")?.innerHTML.trim();
    if (!sizesHtml) return;
    popupContent.innerHTML = sizesHtml;
    mobilePopup.classList.add("is-active");
  });

  //  Close Popup
  const closePopup = () => {
    mobilePopup.classList.remove("is-active");
  };

  closeBtn.addEventListener("click", closePopup);

  // Close if clicking outside the wrapper
  mobilePopup.addEventListener("click", (e) => {
    if (e.target === mobilePopup) closePopup();
  });
}

// --------- close description accordion in mobile device -----------
function manageDescAccordionsByScreen() {
  const accordions = document.querySelectorAll(
    ".product-description-wrapper details",
  );
  if (accordions.length === 0) return;

  const isMobile = window.matchMedia("(max-width: 749px)");

  const updateAccordions = (e) => {
    accordions.forEach((accordion) => {
      if (e.matches) {
        accordion.removeAttribute("open");
      } else {
        accordion.setAttribute("open", "");
      }
    });
  };
  // Initial check on page load
  updateAccordions(isMobile);
  // for screen resize/orientation changes
  isMobile.addEventListener("change", updateAccordions);
}

//Menu Drawer tabs
function initMenuDrawerTabs(){
  // Tab switching
  document.querySelectorAll(".alo-tab").forEach(function (tab) {
    tab.addEventListener("click", function (e) {
      e.stopPropagation();
      const idx = this.dataset.index;
      document.querySelectorAll(".alo-tab").forEach((t) => {
        t.classList.remove("alo-tab--active");
        t.setAttribute("aria-selected", "false");
      });
      document
        .querySelectorAll(".alo-panel")
        .forEach((p) => p.classList.remove("alo-panel--active"));
      // Close any open grandpanels when switching tabs
      document
        .querySelectorAll(".alo-grandpanel--active")
        .forEach((p) => p.classList.remove("alo-grandpanel--active"));
      this.classList.add("alo-tab--active");
      this.setAttribute("aria-selected", "true");
      document
        .querySelector(`.alo-panel[data-index="${idx}"]`)
        .classList.add("alo-panel--active");
    });
  });

  // Open grandchild panel
  document
    .querySelectorAll(".alo-submenu__item--has-children")
    .forEach(function (item) {
      item.addEventListener("click", function (e) {
        e.stopPropagation();
        const panelId = this.dataset.openPanel;
        const panel = document.getElementById(panelId);
        panel.classList.add("alo-grandpanel--active");
        panel.scrollTop = 0;
        let el = item.parentElement;
        while (el) {
          if (el.scrollTop > 0) el.scrollTop = 0;
          el = el.parentElement;
        }
      });
    });

  // Back button — close grandchild panel
  document.querySelectorAll(".alo-back-btn").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      const panelId = this.dataset.closePanel;
      document
        .getElementById(panelId)
        .classList.remove("alo-grandpanel--active");
    });
  });
}

// Megamenu Hover
document.querySelectorAll(".mega-menu").forEach(function (details) {
  details.addEventListener("mouseenter", function () {
    this.setAttribute("open", "");
  });
  details.addEventListener("mouseleave", function () {
    this.removeAttribute("open");
  });
});

//------------- Custom Horizontal Scrollbar for sliders -----------
function initSliderHorizontalScrollbar(){
  const sliderContainers = document.querySelectorAll('.js-slider-container');
  if (sliderContainers && sliderContainers.length > 0) {
    sliderContainers.forEach((slider) => {
      // Find the specific track and thumb belonging ONLY to this slider block
      const wrapper = slider.closest('slider-component');
      const thumb = wrapper.querySelector('.js-scroll-thumb');
      const track = thumb.parentElement;

      let isDragging = false;
      let startX, startScrollLeft;

      // Function to update this specific thumb's width and position
      function updateThumb() {
        const contentWidth = slider.scrollWidth;
        const visibleWidth = slider.clientWidth;
        const trackWidth = track.clientWidth;

        // Skip math if content doesn't overflow (no scrollbar needed)
        if (contentWidth <= visibleWidth) {
          track.style.display = 'none';
          return;
        } else {
          track.style.display = 'block';
        }

        // Dynamic width calculation based on parent widths
        const thumbWidth = (visibleWidth / contentWidth) * trackWidth;
        thumb.style.width = `${Math.max(thumbWidth, 20)}px`; // Min 20px

        const maxScroll = contentWidth - visibleWidth;
        const maxThumbMove = trackWidth - thumb.clientWidth;
        
        const scrollRatio = slider.scrollLeft / maxScroll;
        thumb.style.left = `${scrollRatio * maxThumbMove}px`;
      }

      // Drag Events scoped strictly to this instance
      thumb.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.clientX - thumb.offsetLeft;
        startScrollLeft = slider.scrollLeft;
        document.body.style.userSelect = 'none';
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        
        const maxThumbMove = track.clientWidth - thumb.clientWidth;
        let thumbLeft = e.clientX - startX;
        
        thumbLeft = Math.max(0, Math.min(thumbLeft, maxThumbMove));
        
        const scrollRatio = thumbLeft / maxThumbMove;
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        slider.scrollLeft = scrollRatio * maxScroll;
      });

      document.addEventListener('mouseup', () => {
        isDragging = false;
        document.body.style.userSelect = 'auto';
      });

      // Listeners bound strictly to this individual slider
      slider.addEventListener('scroll', updateThumb);
      window.addEventListener('resize', updateThumb);

      // Initialize this specific slider instance
      updateThumb();
    });
  }
}

// --------- function for refresh cart drawer data ---------
async function refreshCartDrawerAndBubble() {
  const cartDrawerElement = document.querySelector('cart-drawer');
  const cartIconBubble = document.getElementById('cart-icon-bubble');
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-drawer,cart-icon-bubble`);
    const sections = await response.json();

    const parser = new DOMParser();

    // Handle Cart Drawer Update
    if (cartDrawerElement && sections['cart-drawer']) {
      const drawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      const freshDrawerHTML = drawerDoc.querySelector('cart-drawer');
      if (freshDrawerHTML) {
        cartDrawerElement.replaceWith(freshDrawerHTML);
      }
    }

    // Handle Cart Icon Bubble Update
    if (cartIconBubble && sections['cart-icon-bubble']) {
      const bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      const freshBubbleHTML = bubbleDoc.body.innerHTML;
      
      if (freshBubbleHTML.trim() !== "") {
        cartIconBubble.innerHTML = freshBubbleHTML;
      }
    }
  } catch (error) {
    console.error('Error updating cart elements:', error);
  }
}

// --------- refresh cart drawer data when click on back_forward button ---------
(function() {
  window.addEventListener('pageshow', function (event) {
    const isBackNavigation = event.persisted || 
      (window.performance && window.performance.getEntriesByType("navigation")[0]?.type === "back_forward");

    if (isBackNavigation) {   
      setTimeout(() => {     
        refreshCartDrawerAndBubble();
      })
    }
  });
})();

// ---------- Update validation message for newsletter form -----------------
function initNewsletterValidation() {
  const formWrapper = document.querySelector('.footer-block__newsletter');
  if (!formWrapper) return;

  const emailInput = formWrapper.querySelector('input[type="email"]');
  const consentCheckbox = document.querySelector('.newsletter-form input[type="checkbox"]');
  const safeEmailPattern = '[A-Za-z0-9._%+\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,}';

  const errorMessages = {
    emailEmpty: window.newsletterStrings.emailEmptyError,
    emailWhitespace: window.newsletterStrings.emailWhitespaceError,
    emailMissingAt: window.newsletterStrings.emailMissingAtError,
    emailIncomplete: window.newsletterStrings.emailIncompleteError,
    emailInvalidFormat: window.newsletterStrings.emailInvalidFormatError,
    checkbox: window.newsletterStrings.checkboxValidationMessage
  };

  // Validation Events to Email Input Field
  if (emailInput) {
    if (!emailInput.hasAttribute('pattern')) {
      emailInput.setAttribute('pattern', safeEmailPattern);
    }

    emailInput.addEventListener('invalid', (event) => {        
      updateValidationMessage(event.target);
    });
    
    emailInput.addEventListener('input', (event) => {
      event.target.setCustomValidity('');
    });
  }

  // Validation Events to Consent Checkbox
  if (consentCheckbox) {
    consentCheckbox.addEventListener('invalid', (event) => {
      event.target.setCustomValidity(errorMessages.checkbox);
    });

    consentCheckbox.addEventListener('change', (event) => {
      event.target.setCustomValidity('');
    });
  }

  emailInput.addEventListener('input', (event) => {
    updateValidationMessage(event.target);
  });

  function updateValidationMessage(input){
    if (input.validity.valueMissing) {
      input.setCustomValidity(errorMessages.emailEmpty);
    } 
    else if (input.validity.typeMismatch) {
      if (input.value.includes('@')) {
        const err_msg = input.value.includes(' ') ? errorMessages.emailWhitespace : errorMessages.emailIncomplete.replace('[value]', input.value);
        input.setCustomValidity(err_msg);
      } else {
        input.setCustomValidity(errorMessages.emailMissingAt.replace('[value]', input.value));
      }
    }
    else if (input.validity.patternMismatch) {
      input.setCustomValidity(errorMessages.emailInvalidFormat)
    }
  }
}

// --------- Infinity scroll function for collection page --------
function initInfiniteScroll() {
  const gridContainer = document.getElementById("product-grid");
  const paginationContainer = document.querySelector(".pagination-wrapper");
  
  if (!gridContainer || !paginationContainer) return;
  let isPaginationLoading = false;
  const paginationList = paginationContainer.querySelector(".pagination__list");
  const paginationLoader = paginationContainer.querySelector(".pagination__spinner");
  // Helper function to extract the "Next" page URL from DOM structure
  function getNextPageUrl(container) {
    const nextArrow = container.querySelector('.pagination__item--prev');
    return nextArrow ? nextArrow.getAttribute("href") : null;
  }

  // Define the target URL initially using the current document
  let nextPageUrl = getNextPageUrl(document);

  // Hide the default pagination links from view since scroll will take over
  paginationList.style.display = "none";

  async function loadMoreProducts() {
    // Stop if there is no next page, or if a fetch request is already running    
    if (!nextPageUrl || isPaginationLoading) return;
    isPaginationLoading = true;
    if (paginationLoader) paginationLoader.classList.remove("hidden");
    try {
      const response = await fetch(nextPageUrl);
      if (!response.ok) throw new Error("Network response was not ok");
      
      const htmlText = await response.text();
      const parser = new DOMParser();
      const nextDoc = parser.parseFromString(htmlText, "text/html");
      const newProducts = nextDoc.querySelectorAll("#product-grid > *");
      
      // Append the new product cards directly into your existing grid layout
      if (newProducts.length > 0) {
        const fragment = document.createDocumentFragment();
        newProducts.forEach(product => fragment.appendChild(product));
        updateSwatchesNumber(fragment);
        gridContainer.appendChild(fragment);
        positionActiveSwatchInventoryTags(gridContainer);
      }

      // Scan the fetched document to update the reference link for the next scroll loop
      nextPageUrl = getNextPageUrl(nextDoc);

    } catch (error) {
      console.error("Error loading infinite scroll products:", error);
    } finally {
      isPaginationLoading = false;
      if (paginationLoader) paginationLoader.classList.add("hidden");
    }
  }

  if (paginationContainer) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // If the pagination wrapper becomes visible on screen, trigger the load
        if (entry.isIntersecting) {
          loadMoreProducts();
        }
      });
    }, {
      threshold: 0, 
      rootMargin: "0px 0px 200px 0px" 
    });

    // Start watching the pagination element
    observer.observe(paginationContainer);
  }
}
function filterColorTextDesktop() {
  function findHoverLabel(swatchLabelEl) {
    let container = swatchLabelEl.closest('details');
    if (!container) return null;
    return container.querySelector('[data-color-hover-label]');
  }

  function getColorName(swatchLabelEl) {
    return swatchLabelEl.getAttribute('data-color-label') || swatchLabelEl.getAttribute('title') || '';
  }

  document.addEventListener('mouseover', function (event) {
    let swatchLabel = event.target.closest('.color-swatch-circle-label');
    if (!swatchLabel) return;
    let colorName = getColorName(swatchLabel);
    if (!colorName) return;
    let hoverLabel = findHoverLabel(swatchLabel);
    if (hoverLabel) {
      hoverLabel.textContent = colorName;
    }
  });

  document.addEventListener('mouseout', function (event) {
    let swatchLabel = event.target.closest('.color-swatch-circle-label');
    if (!swatchLabel) return;
    let related = event.relatedTarget && event.relatedTarget.closest
      ? event.relatedTarget.closest('.color-swatch-circle-label')
      : null;
    if (related && findHoverLabel(related) === findHoverLabel(swatchLabel)) return;
    let hoverLabel = findHoverLabel(swatchLabel);
    if (hoverLabel) {
      hoverLabel.textContent = '';
    }
  });
}

function mobileFilterLayout() {
  document.addEventListener(
    'click',
    function (event) {
      const summary = event.target.closest('.mobile-facets__details > summary');
      if (!summary) return;
      event.stopPropagation();
    },
    true
  );

  document.addEventListener(
    'toggle',
    function (event) {
      const details = event.target;
      if (!details.classList || !details.classList.contains('mobile-facets__details')) return;
      const summary = details.querySelector(':scope > summary');
      if (summary) {
        summary.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
      }
    },
    true
  );

  document.querySelectorAll('.mobile-facets__details.menu-opening').forEach(function (details) {
    details.classList.remove('menu-opening');
  });
  document.querySelectorAll('.has-submenu.submenu-open').forEach(function (el) {
    el.classList.remove('submenu-open');
  });
}

/* --------- custom sort function for mobile --------- */
function initCustomMobileSorting() {
  const filterContainer = document.getElementById('FacetFiltersFormMobile');
  if (!filterContainer) return;

  if (filterContainer.dataset.sortListenerAttached === 'true') return;

  // Monitor all clicks inside the filter container globally
  filterContainer.addEventListener('click', (event) => {
    const customLabel = event.target.closest('.custom-mobile-sort-label');
    if (!customLabel) return; 

    event.preventDefault();

    const selectedValue = customLabel.getAttribute('data-value');
    const nativeMobileSelect = document.getElementById('SortBy-mobile');

    if (nativeMobileSelect && selectedValue) {
      nativeMobileSelect.value = selectedValue;
      const facetsForm = nativeMobileSelect.closest('facet-filters-form');
      
      if (facetsForm && typeof facetsForm.onSubmitHandler === 'function') {
        facetsForm.onSubmitHandler(event);
      } else {
        // Dynamic fallback protection
        nativeMobileSelect.dispatchEvent(new Event('input', { bubbles: true }));
        nativeMobileSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
}

/* --------- custom sort function for desktop --------- */
function syncSortDropdownLabels() {
  document.querySelectorAll('sort-dropdown').forEach(function (container) {
    const label = container.querySelector('[data-sort-trigger-label]');
    const active = container.querySelector('.sort-dropdown__option.active');
    if (!label || !active) return;
    if (label.textContent !== active.dataset.sortLabel) {
      label.textContent = active.dataset.sortLabel;
    }
  });
}

function sortDropdownLayout() {
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('.sort-dropdown__trigger');
    const option = event.target.closest('.sort-dropdown__option');
    const dropdown = event.target.closest('sort-dropdown');

    if (trigger) {
      const container = trigger.closest('sort-dropdown');
      const list = container.querySelector('.sort-dropdown__list');
      const isOpen = !list.hidden;
      list.hidden = isOpen;
      trigger.setAttribute('aria-expanded', String(!isOpen));
      container.setAttribute('data-open', String(!isOpen));
      return;
    }

    if (option) {
      const container = option.closest('sort-dropdown');
      const select = container.querySelector('.sort-dropdown__native-select');
      select.value = option.dataset.sortValue;
      select.dispatchEvent(new Event('input', { bubbles: true }));

      container.querySelectorAll('.sort-dropdown__option').forEach((btn) => btn.classList.remove('active'));
      option.classList.add('active');
      syncSortDropdownLabels();

      container.querySelector('.sort-dropdown__list').hidden = true;
      container.querySelector('.sort-dropdown__trigger').setAttribute('aria-expanded', 'false');
      container.setAttribute('data-open', 'false');
      return;
    }

    if (!dropdown) {
      document.querySelectorAll('sort-dropdown[data-open="true"]').forEach(function (container) {
        container.querySelector('.sort-dropdown__list').hidden = true;
        container.querySelector('.sort-dropdown__trigger').setAttribute('aria-expanded', 'false');
        container.setAttribute('data-open', 'false');
      });
    }
  }, true);

  document.addEventListener('facets:updated', syncSortDropdownLabels);
  syncSortDropdownLabels();
}

// --------- Recently Viewed Products function -----------
function initRecentlyViewed() {
  const sections = document.querySelectorAll('[data-recently-viewed-section]');
  if (!sections.length) return;

  const STORAGE_KEY = 'alo_recently_viewed_products';
  const MAX_ITEMS = 15;

  sections.forEach(async (sectionEl) => {
    const sectionId = sectionEl.getAttribute('data-section-id');
    const currentHandle = sectionEl.getAttribute('data-product-handle');
    let rootUrl = sectionEl.getAttribute('data-root-url') || '/';
    if (!rootUrl.endsWith('/')) rootUrl += '/';

    // 1. Record Current Product Handle into LocalStorage
    if (currentHandle) {
      let items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      items = items.filter(handle => handle !== currentHandle);
      items.unshift(currentHandle);
      if (items.length > MAX_ITEMS) {
        items = items.slice(0, MAX_ITEMS);
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    }

    // 2. Fetch and Render Recently Viewed Products
    const containerEl = document.getElementById(`RecentlyViewedContainer-${sectionId}`);
    if (!containerEl) return;

    let items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    const handlesToFetch = items.filter(handle => handle && handle !== currentHandle);

    if (handlesToFetch.length === 0) return;

    const cardPromises = handlesToFetch.map(handle =>
      fetch(`${rootUrl}products/${handle}?section_id=${sectionId}`)
        .then(res => res.ok ? res.text() : null)
        .catch(() => null)
    );

    const htmlResults = (await Promise.all(cardPromises)).filter(html => html !== null && html.trim() !== '');

    if (htmlResults.length === 0) return;

    const parser = new DOMParser();
    const cardNodesHtml = htmlResults.map(html => {
      const doc = parser.parseFromString(html, 'text/html');
      const card = doc.querySelector('.rv-card-template-render .product-carousel--wrapper');
      return card ? card.outerHTML : '';
    }).join('');

    if (!cardNodesHtml) return;

    containerEl.innerHTML = cardNodesHtml;
    sectionEl.style.display = 'block';
    updateSwatchesNumber(containerEl);
    positionActiveSwatchInventoryTags(containerEl);

    const leftBtn = document.getElementById(`rv-arrow-left-${sectionId}`);
    const rightBtn = document.getElementById(`rv-arrow-right-${sectionId}`);

    if (leftBtn && rightBtn && containerEl) {
      function updateArrowVisibility() {
        const hasOverflow = containerEl.scrollWidth > containerEl.clientWidth + 2;

        if (!hasOverflow) {
          leftBtn.style.display = 'none';
          rightBtn.style.display = 'none';
          return;
        }

        const isAtStart = containerEl.scrollLeft <= 5;
        leftBtn.style.display = isAtStart ? 'none' : 'flex';

        const isAtEnd = Math.ceil(containerEl.scrollLeft + containerEl.clientWidth) >= containerEl.scrollWidth - 5;
        rightBtn.style.display = isAtEnd ? 'none' : 'flex';
      }

      leftBtn.addEventListener('click', () => {
        containerEl.scrollBy({ left: -320, behavior: 'smooth' });
      });
      rightBtn.addEventListener('click', () => {
        containerEl.scrollBy({ left: 320, behavior: 'smooth' });
      });

      containerEl.addEventListener('scroll', updateArrowVisibility);
      window.addEventListener('resize', updateArrowVisibility);

      updateArrowVisibility();
    }
  });
}

// --------- GWP Validation function -----------
function validateGwpOnLoad(event) {
  if (!window.gwpValidation?.length) return;

  window.gwpValidation.forEach(({ action, lineIndex }) => {
    if (!lineIndex) return;

    if (action === 'remove') {
      removeGwp(lineIndex, event);
    }

    if (action === 'update') {
      removeGwp(lineIndex, event, 1);
    }
  });
  }

// --------- Intercept checkout for non-returnable items ---------
function initNonReturnableCheckout() {
  document.addEventListener('click', async function (e) {
    const checkoutBtn = e.target.closest('button[name="checkout"], #CartDrawer-Checkout, #checkout, .btn-checkout-sticky');
    if (!checkoutBtn) return;

    const pendingItems = document.querySelectorAll('.js-non-returnable-item');
    if (pendingItems.length === 0) return; 

    e.preventDefault();
    e.stopImmediatePropagation();

    checkoutBtn.disabled = true;

    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    try {
      for (const el of pendingItems) {
        const key = el.dataset.key;
        const qty = parseInt(el.dataset.qty, 10);
        const props = JSON.parse(el.dataset.props);

        await fetch(rootUrl + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: key,
            quantity: qty,
            properties: props
          })
        });
      }
    } catch (err) {
      console.error('Non-returnable property update error:', err);
    }

    window.location.href = rootUrl + 'checkout';
  }, true); 
}

//  ---- check for shared size selection on page load and update size value accordingly ----
function initSharedSizeOnLoad() {
  const currentPath = window.location.pathname;
  const productCode = currentPath.split('/').pop().split('-')[0];

  // Fetch and parse the single JSON session object
  const savedData = JSON.parse(sessionStorage.getItem('shared_product_group_data') || '{}');
  const savedGroupCode = savedData?.active_product_group;
  const savedSize = savedData?.shared_selected_size;

  // Condition check: If the code changes or doesn't exist, clear session data
  if (!productCode || !savedSize || (savedGroupCode && savedGroupCode !== productCode)) {
    sessionStorage.removeItem('shared_product_group_data');
    return;
  }

  // If the group code matches and a size is saved, update the size value
  if (savedSize && savedGroupCode === productCode) {
    const selectedSize = document.querySelector(`.product-size__container input[value="${savedSize}"]`);
    if (selectedSize) {
      selectedSize.checked = true;
      selectedSize.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

// ==========================================
// Initialize function on DOM content load
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
  customQuickATC();
  updateProductCardOnSwatchClick();
  updateSwatchesNumber();
  positionActiveSwatchInventoryTags();
  quickATCPopupMobile();
  manageDescAccordionsByScreen();
  initMenuDrawerTabs();
  initSliderHorizontalScrollbar();
  initNewsletterValidation();
  initInfiniteScroll();
  filterColorTextDesktop();
  mobileFilterLayout();
  initCustomMobileSorting();
  sortDropdownLayout();
  initRecentlyViewed();
  validateGwpOnLoad();
  initNonReturnableCheckout();
  initSharedSizeOnLoad();
});

// ==========================================
// Call function on screen resize
// ==========================================
window.addEventListener("resize", () => {
  updateSwatchesNumber();
  positionActiveSwatchInventoryTags();
});

class AloCustomCountry extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.button = this.querySelector('.alo-custom-country-btn');
    this.popup = this.querySelector('.alo-custom-country-popup');
    this.selectedLabel = this.querySelector('.aloCustomSelectedCountry');
    this.redirectModal = document.getElementById('AloCountryRedirectModal');
    this.pendingRedirectUrl = null;

    if (!this.button || !this.popup || !this.selectedLabel) return;

    this.close = () => {
      this.popup.classList.remove('alo-custom-country-popup--open');
      this.button.setAttribute('aria-expanded', 'false');
    };

    this.button.addEventListener('click', (event) => {
      event.stopPropagation();
      this.button.setAttribute(
        'aria-expanded',
        String(this.popup.classList.toggle('alo-custom-country-popup--open'))
      );
    });

    this.popup.addEventListener('click', (event) => {
      event.stopPropagation();
      const option = event.target.closest('.alo-custom-country-option');
      if (!option) return;

      const redirectUrl = option.dataset.redirectUrl;
      if (redirectUrl) {
        event.preventDefault();
        this.pendingRedirectUrl = redirectUrl;
        this.close();
        this.redirectModal?.show(this.button);
        return;
      }

      const href = option.getAttribute('href');
      if (!href || href === '#') event.preventDefault();

      this.popup.querySelectorAll('.alo-custom-country-option').forEach((item) => {
        const selected = item === option;
        item.setAttribute('aria-current', String(selected));
        item
          .querySelector('.alo-custom-country-option__check')
          ?.classList.toggle('alo-custom-country-option__check--hidden', !selected);
      });

      this.selectedLabel.textContent = option.dataset.country || option.textContent.trim();
      this.close();
    });

    this.redirectModal?.querySelector('.alo-country-redirect-modal__continue')?.addEventListener('click', () => {
      if (this.pendingRedirectUrl) window.location.href = this.pendingRedirectUrl;
    });

    this.redirectModal?.querySelector('#ModalClose-AloCountryRedirect')?.addEventListener('click', () => {
      this.pendingRedirectUrl = null;
    });

    this.redirectModal?.addEventListener('click', (event) => {
      if (event.target === this.redirectModal) this.pendingRedirectUrl = null;
    });
  }

  connectedCallback() {
    this.close && document.addEventListener('click', this.close);
  }

  disconnectedCallback() {
    this.close && document.removeEventListener('click', this.close);
  }
}

customElements.define('alo-custom-country', AloCustomCountry);
